// Runtime endpoint: the enabled modules of the active program that the logged-in user's roles
// may see, already filtered and ordered by the server. The admin endpoints that configure
// modules are called from mission-control-mgmt-ui (Admin Configurations > External Modules).
export const API_AVAILABLE_EXTERNAL_MODULES = '/api/external-modules/available';

export const EXTERNAL_MODULE_PLACEMENT = {
  LEFT_NAV: 'LEFT_NAV',
  PARTICIPANT_PROFILE_TAB: 'PARTICIPANT_PROFILE_TAB',
};

export const EXTERNAL_MODULE_ROUTE_PREFIX = '/externalModule';

export const EXTERNAL_MODULE_NAV_ICON = 'fa-solid fa-puzzle-piece';

// Same convention as the other externally hosted nav items (see getFeatureNavItems).
export const EXTERNAL_MODULE_NAV_INDEX = 20;

// A module may only be hosted on these domains (and their subdomains).
export const ALLOWED_MODULE_HOST_SUFFIXES = ['vibrenthealth.com', 'vibrentdocs.com'];

// Messages are tagged with this so a child can tell them apart from other window messages.
export const HOST_ID = 'research_cloud';

export const HOST_MESSAGE_TYPES = {
  CONTEXT: 'context',
  TOKEN_REFRESH: 'token_refresh',
};

export const CHILD_MESSAGE_TYPES = {
  READY: 'ready',
  NAVIGATE: 'navigate',
};

export const IFRAME_SANDBOX =
  'allow-scripts allow-same-origin allow-forms allow-popups allow-downloads';

// Other modules (e.g. the participant profile in the scheduler) read the shared frame
// component from state.modules, the same way they read each other's exported components.
export const CORE_MODULE_NAME = '_com_vibrenthealth_missioncontrol_core';
export const EXTERNAL_MODULE_FRAME_COMPONENT = 'ExternalModuleFrame';
